import {
  USER_OBJECT,
  USER_PLUGGTO_TOKENS,
  USER_APP_TOKEN,
  SET_PLUGGTOCODE
} from '../mutation-types';

const mutations = {
  [USER_OBJECT](state, data) {
    state.user = data;
  },
  [USER_PLUGGTO_TOKENS](state, data) {
    state.user.pluggToTokens = data;
  },
  [USER_APP_TOKEN](state, data) {
    state.user.token = data.token;
  },
  [SET_PLUGGTOCODE](state, data) {
    state.pluggtocode = data;
  }
};

const state = {
  user: {
    pluggToUserId: 0,
    pluggToEmail: '',
    pluggToName: '',
    pluggToSubuser: null,
    pluggToTokens: {
      accessToken: '',
      refreshToken: '',
      expireAt: ''
    },
    token: '',
    marketplace: '',
    createdAt: '',
    pluggToErpDefault: null,
  },
  pluggtocode: null
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/user.js